

import React, { useEffect } from 'react';
import { Pagination } from 'antd';
import BlogSection from './BlogListingsSection';

const Blogs = (props) => {
  const { history, numberOfPeople, featuredArticle, resetPagination, getPeopleNeededForHelp, setPage, getFeaturedArticles, getBlogs, blogs, loading, pagination } = props;
  const { data, total } = blogs;
  const { video: video_url } = featuredArticle || {};

  useEffect(() => {
    getFeaturedArticles();
    getBlogs();
    getPeopleNeededForHelp();
    return () => resetPagination();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps 
  let formattedVideoUrl = video_url || 'https://www.youtube.com/embed/j7KKZ6v5o34';
  if (video_url) {
    const [firstUrlPart, secondUrlPart] = formattedVideoUrl.split('watch?v=');
    formattedVideoUrl = `${firstUrlPart}embed/${secondUrlPart}`;
  }
  
  return (
    <div className="blog-page-wrap">
      <section className="banner-bg  banner-second blog-banner">
        <div className="container-fluid  ">
          <div className="row d-flex align-items-center ">
            <div className="col-xl-8 col-lg-8 col-md-9 d-none d-md-block"> <img src="/images/banner-3.png" className="img-fluid" alt="" /> </div>
            <div className="col-xl-4 col-lg-4 col-md-4  banner-content-wraper    ">
              <div className="banner-content">
                <h1>How to travel the world and get big companies to pay for it </h1>
                <p className="">More off this less hello salamander lied porpoise much over tightly circa horse taped so innocuously outside crud mightily rigorous…</p> <i className="fa fa-arrow-right mb-2"></i>
                <ul>
                  <li><a href='/homepage' title=""><i className="fa fa-facebook"></i></a></li>
                  <li><a href='/homepage' title=""><i className="fa fa-twitter"></i></a></li>
                  <li><a href='/homepage' title=""><i className="fa fa-youtube"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="featured-articles mt-5 blog-sec-2">
        <div className="container">
          <h4 className="sub-tittle">Featured Blogs</h4>
          <div className="row">
            <div className="col-lg-7 col-md-7 col-sm-12 featured-articles-img">
              <iframe
                title='featuredArticle'
                width="100%"
                height="315"
                src={formattedVideoUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen>
              </iframe>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12  text-center">
              <div className="need-our need-our-bg blog-sec-2-img">
                <div>
                  <h4>{numberOfPeople} Peoples<span className="d-block  "> Need Ours Help</span></h4>
                  <button onClick={() => history.push('/starting_fund')} type="button" className="btn btn-success  ml-2  ">Start fundraising</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BlogSection 
        history={history} 
        data={data} 
        loading={loading} 
      />
      <section className="" style={{ marginBottom: '50px' }}>
        <div className="container">
          <div style={{ float: 'right' }} className="row">
            <Pagination
              onChange={(page) => {
                setPage(page);
                getBlogs();
              }}
              size='small'
              current={pagination.pageNumber}
              defaultPageSize={pagination.pageSize}
              total={total}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blogs;
